import { Box, Flex, VStack, useBreakpointValue } from '@chakra-ui/react';
import { MerkatusLogo } from 'src/components/atoms/MerkatusLogo';
import FooterLinks from '../../molecules/FooterLinks';

const MarketingPageFooter: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box
      bg="text.darkBlue.900"
      color="white"
      py="72px"
      px={{ base: 4, md: '72px' }}>
      {isMobile ? (
        <VStack mx="auto" align="stretch" spacing={16}>
          {/* Newsletter section */}
          {/* <FooterNewsletter /> */}
          {/* Logo & Links */}
          <VStack align="stretch" spacing={6}>
            <MerkatusLogo />
            <FooterLinks
              columns={2}
              spacing={6}
              headingFontSize="16px"
              itemFontSize="14px"
            />
          </VStack>
        </VStack>
      ) : (
        <Flex
          maxW="100%"
          mx="auto"
          direction="row"
          justify="space-between"
          align="flex-start"
          gap={8}>
          <Box minW="180px">
            <MerkatusLogo />
          </Box>
          <FooterLinks
            columns={4}
            spacing={20}
            headingFontSize="16px"
            itemFontSize="14px"
          />
          {/* <FooterNewsletter boxWidth="574px" /> */}
        </Flex>
      )}
    </Box>
  );
};

export default MarketingPageFooter;
